// workspaceMode.js — THE WORKSPACE OR ITS CLI (Nika 2026-10-23: "add switcher
// so we can switch between normal and CLI-like workspace easily").
//
// One workspace, two ways to have it: the normal shell, or Agent mode — the
// workspace TUI as the whole shell (functions/agentMode.js, WS-AGENT-MODE-1;
// its own choice, persisted per person). One switch, "Workspace · CLI"
// (components/WorkspaceModeSwitch.js), in both shells: at the top of the home,
// at the start of the home's views row (components/HomeViewSwitch.js — clear
// of the Fly rail at the right edge), and in the Agent frame's header where its
// Leave was. Ctrl+` flips it anywhere (functions/shortcutsDefault.js; the
// frame's key bridge, functions/agentModeRuntime.js agentModeKeydown).
//
// FRANK: every export is self-contained (FA204); siblings through `this.call`.

// 'cli' while the Agent frame is the shell (the person's choice or a link),
// else 'ui'.
export const workspaceModeOf = function workspaceModeOf(root) {
  const r = root && typeof root === 'object' ? root : {}
  return r.agentMode === true || r._agentModeLink === true ? 'cli' : 'ui'
}

// The switch's rows — AppSegmented's row contract (`text` is a bundle key;
// keys prefixed so no state key names an HTML tag).
export const workspaceModeSegments = function workspaceModeSegments() {
  return [
    { key: 'modeUi', value: 'ui', text: 'workspace.agentMode.ui' },
    { key: 'modeCli', value: 'cli', text: 'workspace.agentMode.cli' }
  ]
}

// Offered to a signed-in person in a shell that has Agent mode — never while
// the home board is being edited (the edit stays the screen's one task).
export const workspaceModeShown = function workspaceModeShown(root) {
  const r = root && typeof root === 'object' ? root : {}
  const fns = (this && this.context && this.context.functions) || {}
  const signedIn = r.signedIn === true
  const editing = !!r._homeCustomizeMode
  return signedIn && !editing && typeof fns.setAgentMode === 'function'
}

// The switch's choice (AppSegmented `select`): the person's Agent mode choice,
// written the way the header's entry and the frame's leave write it.
export const workspaceModeSelect = function workspaceModeSelect(value) {
  const root = this && this.state && this.state.root
  if (!root || (value !== 'ui' && value !== 'cli')) return false
  if (this.call('workspaceModeOf', root) === value) return false
  this.call('setAgentMode', value === 'cli')
  return true
}

// Ctrl+` (functions/shortcutsDefault.js, the Agent frame's key bridge): the
// other one.
export const workspaceModeToggle = function workspaceModeToggle() {
  const root = this && this.state && this.state.root
  if (!root) return false
  return this.call(
    'workspaceModeSelect',
    this.call('workspaceModeOf', root) === 'cli' ? 'ui' : 'cli'
  )
}
